import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import FeedSection from "@/pages/home/components/FeedSection";
import TrendSection from "@/pages/home/components/TrendSection";
import RankingSection from "@/pages/home/components/RankingSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";
import { feedItems } from "@/mocks/content";

export default function Home() {
  const [keyword, setKeyword] = useState("");

  const pickWord = (word: string) => {
    setKeyword(word);
    document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar onSearch={setKeyword} totalHot={feedItems.length} />
      <main>
        <Hero />
        <FeedSection keyword={keyword} />
        <TrendSection onPickWord={pickWord} />
        <RankingSection />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}